module.exports = __webpack_public_path__ + "static/WEDDING E&M-54-5936b90741937af9c25f02b825604ec7.jpg";